export const emailExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/